import { PropsWithChildren, ReactNode } from 'react';

import { cn } from '@/lib/utils';

type FormSectionProps = PropsWithChildren<{
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}>;

export const FormSection = (props: FormSectionProps) => {
  const { title, description, action, className, children } = props;

  return (
    <section
      data-slot="form-section"
      className={cn('flex flex-col gap-4', className)}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 flex-col gap-0.5">
          <h2 className="text-foreground text-sm font-semibold">{title}</h2>
          {description && (
            <p className="text-muted-foreground text-xs">{description}</p>
          )}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
};
